import React from 'react';
export const LegendNoMarketingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="4" fill="#575757" />
    <path
      d="M7.444 12.552C7.444 14.1 8.236 15.336 9.712 15.336C11.068 15.336 11.884 14.22 11.884 12.552C11.872 10.872 11.044 9.78 9.652 9.78C8.368 9.78 7.444 10.776 7.444 12.552ZM13.672 18.084H11.812C11.728 18.084 11.656 18.036 11.62 18.012C11.272 17.712 10.696 17.196 10.06 16.596C9.928 16.608 9.796 16.62 9.664 16.62C7.336 16.62 5.956 14.892 5.956 12.552C5.956 10.248 7.456 8.496 9.664 8.496C12.016 8.496 13.36 10.296 13.372 12.516C13.384 14.16 12.712 15.432 11.62 16.092C12.184 16.608 13.18 17.532 13.696 17.988C13.732 18.024 13.72 18.084 13.672 18.084ZM16.7246 16.5H15.4406C15.3686 16.5 15.3446 16.476 15.3446 16.416V10.38C14.9966 10.572 14.4206 10.752 14.0846 10.812C14.0126 10.824 13.9886 10.812 13.9886 10.74V9.72C13.9886 9.66 14.0006 9.636 14.0606 9.624C14.6246 9.48 15.2726 9.204 15.7286 8.904C15.7766 8.868 15.8486 8.856 15.9086 8.856H16.7366C16.7846 8.856 16.7966 8.88 16.7966 8.94V16.416C16.7966 16.476 16.7726 16.5 16.7246 16.5Z"
      fill="white"
    />
  </svg>
);
